import clsx from "clsx";
import React, { memo, useEffect, useState } from "react";
import { Range } from "react-range";
import FieldLabel from "../FieldLabel/FieldLabel";

interface IRangeInput {
  defaultValue?: number;
  min: number;
  max: number;
  label?: string;
  onChange: (value: number) => void;
  step?: number;
  isPercentage?: boolean;
}

const RangeInput: React.FC<IRangeInput> = ({
  defaultValue = 0.1,
  min,
  max,
  label,
  onChange,
  step = 0.1,
  isPercentage = true,
}) => {
  const [value, setValue] = useState<number>(defaultValue);

  useEffect(() => {
    onChange(value);
  }, [value]);

  return (
    <div className={clsx(["flex", "flex-col", "w-full", "gap-2"])}>
      {label && <FieldLabel text={label} />}
      <div
        className={clsx([
          "flex",
          "flex-row",
          "gap-1",
          "items-center",
          "h-[50px]",
        ])}
      >
        <div className={clsx(["flex", "w-full", "flex-shrink"])}>
          <Range
            min={min}
            max={max}
            values={[value]}
            step={step}
            onChange={(values: any[]) => {
              const [first] = values;

              setValue(first);
            }}
            renderTrack={({ props, children }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                }}
                className={clsx([
                  "rounded",
                  "h-[10px]",
                  "w-full",
                  "bg-gray-300",
                  "dark:bg-gray-600",
                ])}
              >
                {children}
              </div>
            )}
            renderThumb={({ props }) => (
              <div
                {...props}
                key={props.key}
                style={{
                  ...props.style,
                }}
                className={clsx([
                  "rounded",
                  "h-[30px]",
                  "w-[20px]",
                  "dark:bg-rose-500",
                  "bg-blue-900",
                ])}
              />
            )}
          />
        </div>
        {isPercentage ? (
          <div className="inline-flex flex-shrink-0 min-w-[40px] justify-end text-xs">
            {value * 100}%
          </div>
        ) : (
          <div className="inline-flex flex-shrink-0 min-w-[40px] justify-end text-xs">
            {value}
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(RangeInput);
